const MULTI_LOOKS_MAX_COUNT = 4;
const MAIN_MODES = { LIVE: 'Live', PHOTO: 'Photo' };
const SECOND_MODES = {
  UPLOAD: 'Upload',
  SELECT: 'Select',
  BEFORE_AFTER: 'BeforeAfter',
  COMPARE: 'Compare',
  ADJUSTING: 'AdjustingMode',
};

const ADJUSTABLE_CATEGORIES = {
  LIPCOLOR: 'lipcolor',
  BROW: 'brow',
};

const ADJUSTABLE_CATEGORIES_ARR = [
  ADJUSTABLE_CATEGORIES.LIPCOLOR,
  ADJUSTABLE_CATEGORIES.BROW,
];

const ADJUSTABLE_LABELS_BY_CATEGORY = {
  [ADJUSTABLE_CATEGORIES.BROW]: 'Move the dots to outline your eyebrows.',
  [ADJUSTABLE_CATEGORIES.LIPCOLOR]: 'Move the dots to outline your lips.',
};

const MASK_OPACITY = 0.5;
const FEATURE_NAME_FOR_LIPS = 'extendedOuterMouth2D';
const FEATURE_NAME_FOR_INNER_MOUTH_2D = 'innerMouth2D';
const FEATURE_NAME_FOR_LEFT_BROW = 'leftFullBrow2D';
const FEATURE_NAME_FOR_RIGHT_BROW = 'rightFullBrow2D';

const FEATURES_BY_CATEGORY_HASH = {
  [ADJUSTABLE_CATEGORIES.BROW]: [FEATURE_NAME_FOR_LEFT_BROW, FEATURE_NAME_FOR_RIGHT_BROW],
  [ADJUSTABLE_CATEGORIES.LIPCOLOR]: [FEATURE_NAME_FOR_LIPS],
};

const ZOOM_FACTOR = {
  [FEATURE_NAME_FOR_LIPS]: 0.6,
  [FEATURE_NAME_FOR_LEFT_BROW]: 0.4,
  [FEATURE_NAME_FOR_RIGHT_BROW]: 0.4,
};

export {
  SECOND_MODES,
  MAIN_MODES,
  MULTI_LOOKS_MAX_COUNT,
  FEATURES_BY_CATEGORY_HASH,
  ADJUSTABLE_CATEGORIES,
  ADJUSTABLE_CATEGORIES_ARR,
  ADJUSTABLE_LABELS_BY_CATEGORY,
  FEATURE_NAME_FOR_LIPS,
  FEATURE_NAME_FOR_INNER_MOUTH_2D,
  MASK_OPACITY,
  ZOOM_FACTOR,
};
